import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
    selector: 'us-mobile-page',
    standalone: true,
    imports: [IonicModule, AsyncPipe, RouterOutlet, TranslocoModule],
    templateUrl: './mobile-page.component.html',
    styleUrls: ['./mobile-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobilePageComponent {
    private readonly route = inject(ActivatedRoute);
    readonly title = this.route.snapshot.data['title'];
}
